import { useState, useEffect } from 'react';
import { get, getDatabase, ref } from 'firebase/database';

export interface Userprofile {
    key: string;
    name: string;
    admin?: boolean;
    accessToWeb?: boolean;
    groups?: string[];
    lastAppStart?: string;
    lastDeviceUsed?: {
        identifierForVendor: string;
        model: string;
        name: string;
        systemName: string;
        systemVersion: string;
    };
    createdBy?: string;
    createdAt?: string;
}

export const useUsersData = () => {
    const [users, setUsers] = useState<Userprofile[] | undefined>(undefined);
    const [loadingUsers, setLoadingUsers] = useState<boolean>(true);
    const [usersError, setUsersError] = useState<Error | null>(null);

    const fetchUsers = async () => {
        setLoadingUsers(true);
        setUsersError(null);

        try {
            const db = getDatabase();
            const buildingsRef = ref(db, 'users/userList');
            const snapshot = await get(buildingsRef);

            if (snapshot.exists()) {
                const data = snapshot.val() as { [key: string]: Userprofile };
                const userPromises = Object.entries(data).map(async ([key, userData]) => {
                    return {...userData, key} as Userprofile;
                });

                const usersArray = await Promise.all(userPromises);
                setUsers(usersArray);
            } else {
                console.log('No users data available in the snapshot');
                setUsers([]);
            }
        } catch (err) {
            console.error('Failed to load users data', err);
            setUsersError(err instanceof Error ? err : new Error('Unknown error'));
        } finally {
            setLoadingUsers(false);
        }
    };

    useEffect(() => {
        fetchUsers().then();
    }, []);

    return {
        users,
        loadingUsers,
        usersError,
        refreshUsers: fetchUsers
    };
};